import { render } from "./ContactsInfo.vue?vue&type=template&id=610761db&scoped=true"
const script = {}

import "./ContactsInfo.vue?vue&type=style&index=0&id=610761db&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610761db"]])

export default __exports__